export default "__VITE_ASSET__D7PZiA0c__"